import { boundsOfShape } from '@/domain/world/geometry';
import type { RegionDefinition } from '@/domain/world/region-definition';

export interface ProceduralPropBounds {
  id: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

function isTerrainCollision(id: string): boolean {
  return id.startsWith('river-') || id.startsWith('cliff-');
}

export function proceduralPropBounds(region: RegionDefinition): ProceduralPropBounds[] {
  return region.collision
    .filter((shape) => !isTerrainCollision(shape.id))
    .map((shape) => ({ id: shape.id, ...boundsOfShape(shape) }));
}
